/* This is ment to build provide a quick starting point when starting new index type file */
import React from 'react';
import strechSectionStyle from './style';
import strechStrip01 from '../../images/ComponentImages/Strip01.png';
import strechStrip02 from '../../images/ComponentImages/Strip02.png';

export default function StrechSection({title, caption, subTitle, texts, mt}) {
	let style = strechSectionStyle();

	return (
		<div style={style.outerStyle({mt: mt})}>
			<img style={style.imageStyle({isBottom: false})} src={strechStrip01} />
			<div style={style.innerContentContainer()}>
				<h1 style={style.titleStyle()}>{title}</h1>
				<p style={style.genericTextStyle()}>{caption}</p>
				<h1 style={style.subtitleTextStyle()}>{subTitle}</h1>
				{texts ? (
					texts.map((text, i) => {
						return (
							<p style={style.genericTextStyle()} key={i}>
								{text}
							</p>
						);
					})
				) : (
					<></>
				)}
			</div>
			<img style={style.imageStyle({isBottom: true})} src={strechStrip02} />
		</div>
	);
}
